import { spaceGroupQueries } from "@circle-react/lib/queries/spaceGroups";
import type { SpaceGroup } from "@circle-react/types/SpaceGroup";
import { useQuery } from "react-query";

/** Show-endpoint fields not present on the list `_record` partial. */
export type SpaceGroupResourceData = Pick<
  SpaceGroup,
  "active_members_count" | "moderator_community_member_ids" | "name"
>;

const selectSpaceGroupResourceData = (
  data: SpaceGroup,
): SpaceGroupResourceData => ({
  name: data.name,
  moderator_community_member_ids: data.moderator_community_member_ids,
  active_members_count: data.active_members_count,
});

export const useSpaceGroupResource = (spaceGroupId?: number) => {
  const queryConfig = spaceGroupQueries.resourceDetail(spaceGroupId);

  const { data, isInitialLoading, refetch, isError } = useQuery({
    ...queryConfig,
    select: selectSpaceGroupResourceData,
  });

  return {
    data,
    isLoading: isInitialLoading,
    isError,
    refetch,
  };
};
